import React from 'react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function Included() {
  const handleCheckoutClick = () => {
    trackInitiateCheckout();
  };
  return <section className="py-[60px] px-5 bg-brand-dark" data-id="element-152">
      <div className="max-w-[860px] mx-auto" data-id="element-153">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-154">
          Lo Que Incluye Tu Compra
        </h2>
        <p className="text-base text-brand-gray text-center mb-10 max-w-[600px] mx-auto" data-id="element-155">
          Todo lo que necesitas para aplicar el Método 4C hoy mismo
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[720px] mx-auto mb-10" data-id="element-156">
          {/* eBook */}
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-5 flex gap-4 items-center transition-colors duration-300 hover:border-brand-red/40" data-id="element-157">
            <div className="text-4xl shrink-0" data-id="element-158">📘</div>
            <div data-id="element-159">
              <h3 className="text-base font-extrabold text-white mb-1" data-id="element-160">
                eBook Completo
              </h3>
              <p className="text-[13px] text-brand-gray" data-id="element-161">
                13 Capítulos · Método 4C
              </p>
            </div>
          </div>

          {/* Plan 21 Días */}
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-5 flex gap-4 items-center transition-colors duration-300 hover:border-brand-red/40" data-id="element-162">
            <div className="text-4xl shrink-0" data-id="element-163">📅</div>
            <div data-id="element-164">
              <h3 className="text-base font-extrabold text-white mb-1" data-id="element-165">
                Plan de 21 Días
              </h3>
              <p className="text-[13px] text-brand-gray" data-id="element-166">Acción día por día</p>
            </div>
          </div>

          {/* Scripts */}
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-5 flex gap-4 items-center transition-colors duration-300 hover:border-brand-red/40" data-id="element-167">
            <div className="text-4xl shrink-0" data-id="element-168">📞</div>
            <div data-id="element-169">
              <h3 className="text-base font-extrabold text-white mb-1" data-id="element-170">
                5 Scripts de Negociación
              </h3>
              <p className="text-[13px] text-brand-gray" data-id="element-171">Español e inglés</p>
            </div>
          </div>

          {/* Plantillas */}
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-5 flex gap-4 items-center transition-colors duration-300 hover:border-brand-red/40" data-id="element-172">
            <div className="text-4xl shrink-0" data-id="element-173">📋</div>
            <div data-id="element-174">
              <h3 className="text-base font-extrabold text-white mb-1" data-id="element-175">
                4 Mini-Plantillas LITE
              </h3>
              <p className="text-[13px] text-brand-gray" data-id="element-176">Papel o teléfono</p>
            </div>
          </div>

          {/* Ejemplos */}
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-5 flex gap-4 items-center transition-colors duration-300 hover:border-brand-red/40 md:col-span-2" data-id="element-177">
            <div className="text-4xl shrink-0" data-id="element-178">📖</div>
            <div data-id="element-179">
              <h3 className="text-base font-extrabold text-white mb-1" data-id="element-180">
                3 Ejemplos Ya Llenos
              </h3>
              <p className="text-[13px] text-brand-gray" data-id="element-181">
                Casos reales completados
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-182">
          <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="btn-buy-main inline-block w-full max-w-[480px] text-white no-underline text-[clamp(16px,3vw,22px)] font-black py-5 px-7 rounded-xl uppercase tracking-[1px] transition-all duration-300 shadow-[0_8px_30px_rgba(230,57,70,0.5)] text-center cursor-pointer border-none hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(230,57,70,0.6)]" data-id="element-183">
            🔥 OBTENER TODO ESTO — $6.39
            <span className="block text-xs font-normal opacity-85 mt-1 normal-case tracking-normal" data-id="element-184">
              Descarga inmediata · Acceso instantáneo
            </span>
          </a>
        </div>
      </div>
    </section>;
}